export const hardRefreshAndEmptyCache = async () => {
  if ("caches" in window) {
    try {
      const keys = await caches.keys();
      keys.forEach((key) => {
        // Delete all the cache files
        caches.delete(key);
      });
    } catch (error) {}
  }
  window.location.reload(true);
};

export const getTitleCaseSentence = (str) => {
  if (!str) {
    return "";
  }
  return `${str}`.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
};

export const getOptionsFromEnum = (_enum) => {
  return Object.keys(_enum).map((key) => {
    return {
      label: key.match(/[A-Z][a-z]+|[0-9]+/g).join(" "),
      value: _enum[key],
    };
  });
};

export const getSelectFilterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

export const sortNumbersInDescending = (arr) => {
  return arr.sort((a, b) => parseInt(b) - parseInt(a));
};

export const getFormattedCurrencyNumber = (value) => {
  return new Intl.NumberFormat("en", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const agreementValidator = (_, value) => {
  if (value === true) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Please agree to the above"));
};

export const getRandomValueFromArray = (arr) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

export const formItemNumberValidator = ({
  allowDecimals = true,
  decimalPlaces = 2,
} = {}) => {
  return (_, value) => {
    if (!value) return Promise.resolve();

    let regex;

    if (allowDecimals) {
      regex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlaces}})?$`);
    } else {
      regex = /^\d+$/;
    }

    return regex.test(value)
      ? Promise.resolve()
      : Promise.reject(
          allowDecimals
            ? `Enter a valid number with up to ${decimalPlaces} decimal place(s)`
            : "Enter a valid whole number"
        );
  };
};
